import { useTranslations as useTranslationsFromNextIntl } from 'next-intl';
import type { IntlMessages } from '@/i18n/messages-typecheck';
import type { NamespaceKeys, NestedKeyOf, _Translator } from 'use-intl/core';
import { trackNamespaceAccess } from '@/i18n/on-i18n-error';

export type ClientTranslationNamespace = NamespaceKeys<IntlMessages, NestedKeyOf<IntlMessages>>;

export function useTranslations<const NS extends ClientTranslationNamespace = never>(
  namespace?: NS,
): _Translator<IntlMessages, NS> {
  trackNamespaceAccess(namespace);

  return useTranslationsFromNextIntl(
    namespace as Parameters<typeof useTranslationsFromNextIntl>[0],
  ) as _Translator<IntlMessages, NS>;
}
